import { Controller } from "stimulus"

export default class extends Controller {

    static targets = ["po_rate_regular", "start_date", "subit_button"]

    validate(e) {
        return true;
        // targets = ["start_date", "po_rate_regular"]
        if (!isDate(this.start_dateTarget.value)){
            alert("Please enter start date")
            e.preventDefault();
           
            // $(this.subit_buttonTarget).attr("disabled", false)
            console.log( "length: " + $('input[data-target="work-contracts.subit_button"]').length)
            $('input[data-target="work-contracts.subit_button"]').attr("disabled", false)
            return false;
        }
        return true;
        
    }

    

}